import React from 'react';

const EmployeeStats = ({ employees }) => {
  const stats = {
    total: employees.length,
    active: employees.filter(emp => emp.active).length,
    departments: [...new Set(employees.map(emp => emp.department).filter(Boolean))].length,
    totalSalary: employees.reduce((sum, emp) => sum + (emp.salary || 0), 0),
    avgSalary: employees.length > 0 
      ? employees.reduce((sum, emp) => sum + (emp.salary || 0), 0) / employees.length 
      : 0
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const statCards = [
    {
      label: 'Total Employees',
      value: stats.total,
      color: 'bg-blue-500',
      icon: '👥'
    },
    {
      label: 'Active Employees',
      value: stats.active,
      color: 'bg-green-500',
      icon: '✅'
    },
    {
      label: 'Departments',
      value: stats.departments,
      color: 'bg-purple-500',
      icon: '🏢'
    },
    {
      label: 'Average Salary',
      value: formatCurrency(stats.avgSalary),
      color: 'bg-yellow-500',
      icon: '💰'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards.map((stat, index) => (
        <div key={index} className="card p-6">
          <div className="flex items-center">
            <div className={`${stat.color} rounded-lg p-3 mr-4`}>
              <span className="text-2xl">{stat.icon}</span>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              <p className="text-sm text-gray-600">{stat.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmployeeStats;